export default __webpack_public_path__ + "static/images/worlds-logo.png";